<template>
  <div/>
</template>

<script>
import {mapGetters} from "vuex";
import ComponentMixin from "@/components/ComponentMixin";

export default {
  mixins: [ComponentMixin],
  type: "page",
  name: "EmailVerification",
  computed: {
    ...mapGetters("user", ["user"])
  },
  watch: {
    "$auth.loading": {
      handler: function(val, old) {
        if (val === false && old === true) {
          if (!this.$auth.isAuthenticated) {
            this.go("/");
          }
        }
      }
    },
    "user.registerService": {
      handler: function (val) {
        if (val === 2) {
          this.go("/");
        } else if (val === 3) {
          this.go("/clients/jobs");
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>